import styled from "styled-components";

export const LegMtpWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
`;
